angular
	.module 'App.Repository'

.factory 'StockLocationRepository', ['BaseRepository', (BaseRepository) ->
	class StockLocationRepository extends BaseRepository
		@resource = '/stock_locations'
		@isRestricted = true

		getProducts: (stockLocationId, query) ->
			return @find("#{stockLocationId}/products", query).then (response) ->
				return response.data

		getProductVariants: (stockLocationId, productId, query) ->
			return @find("#{stockLocationId}/products/#{productId}/variants", query).then (response) ->
				return response.data

	return new StockLocationRepository
]

.factory 'StockMovementsRepository', ['BaseRepository', (BaseRepository) ->
	class StockMovementsRepository extends BaseRepository
		@resource = '/stock_movements'
		@isRestricted = true

	return new StockMovementsRepository
]

.factory 'StockEventsRepository', ['BaseRepository', (BaseRepository) ->
	class StockEventsRepository extends BaseRepository
		@resource = '/stock_events'
		@isRestricted = true

	return new StockEventsRepository
]
.factory 'AddStockRepository', ['BaseRepository', (BaseRepository) ->
	class AddStockRepository extends BaseRepository
		@resource = '/add_stock'
		@isRestricted = true

	return new AddStockRepository

]
.factory 'RemoveStockRepository', ['BaseRepository', (BaseRepository) ->
	class RemoveStockRepository extends BaseRepository
		@resource = '/remove_stock'
		@isRestricted = true

	return new RemoveStockRepository
]
